import React from 'react';
import { Input } from 'antd';
import { SearchProps as SearchCopyProps } from 'antd/lib/input/Search';

export type SearchProps = SearchCopyProps;

const ProInputSearch: React.FC<SearchProps> = React.forwardRef<
  any,
  SearchProps
>((props, ref) => {
  const { children, ...resProps } = props;
  return (
    <Input.Search ref={ref} {...resProps}>
      {children}
    </Input.Search>
  );
});

export default ProInputSearch;
